<template>
    <NuxtLayout :class="css.container" name="main-small">
        <!-- * 下载弹窗 -->
        <ui-modal :class="css.modal" :width="496" :height="310" spacing="32px 56px 48px" ref="modal">
            <div :class="css.title" class="font-bold color-1">{{ $t("Download", 2) }}</div>
            <div>{{ $t("PleaseSelectTheFileYouNeed") }}:</div>
            <div :class="css.button">
                <ui-button :class="css_button.cancel" size="middle" @click="methods.download">{{ file.txt.title }}.txt</ui-button>
            </div>
            <project-route :class="css.button" :to="file.gb.href" target="_blank">
                <ui-button :class="css_button.cancel" size="middle">{{ file.gb.title }}.gb</ui-button>
            </project-route>
        </ui-modal>

        <div :class="css.header" ref="header">
            <!-- * 导航 -->
            <module-navigations :class="css.navigations" :option="modes" :data="data" :id="id" @update="methods.mode" />
            <div class="container">
                <!-- * 控制器 -->
                <div :class="css.controls">
                    <div :class="css.module">
                        <ui-select v-model="id" ref="select1" :width="320" :z-index="67" :candidates="data.mrnas" @change="methods.data">
                            <template #candidate="{ data }">
                                <span :title="data.label" v-html="data.label"></span>
                            </template>
                        </ui-select>
                        <ui-button :class="css_button.append" style="margin-left: 16px" @click="modal?.openModal">
                            {{ $t("DownloadSequence") }}
                        </ui-button>
                        <ui-button v-if="data.specie == 9606" style="margin-left: 16px" :class="css_button.green" @click="methods.next">
                            {{ $t("GeneMutationInfo", { name: data.name }) }}
                        </ui-button>
                    </div>
                    <div :class="css.module">
                        <ui-select v-model="inquire" ref="select2" v-bind="binds.inquire" style="margin-right: 4px" @change="methods.cancel" />
                        <template v-if="inquire == 'exon'">
                            <default-search
                                v-model="exon"
                                :width="264"
                                :option="exons"
                                :placeholder="$t('SearchExonPlaceholder')"
                                :icon="false"
                                @search="
                                    (data) => {
                                        if (data) exon = data?.label;
                                        else exon = exons[0]?.label;
                                    }
                                " />

                            <ui-button :class="css_button.append" :disabled="!exon" style="margin-left: 8px" @click="methods.exon()">{{
                                $t("Confirm")
                            }}</ui-button>
                            <ui-button :class="css_button.append" :disabled="!exon" style="margin-left: 8px" @click="methods.cancel">{{
                                $t("Cancel")
                            }}</ui-button>
                        </template>
                        <template v-else>
                            <ui-scope-input :class="css.input" v-model="coordinate" v-bind="binds.coordinate" />
                            <ui-button
                                :class="css_button.append"
                                :disabled="!(coordinate.end && coordinate.start)"
                                style="margin-left: 8px"
                                @click="methods.coordinate"
                                >{{ $t("Confirm") }}</ui-button
                            >
                            <ui-button
                                :class="css_button.append"
                                :disabled="!(coordinate.end && coordinate.start)"
                                style="margin-left: 8px"
                                @click="methods.cancel"
                                >{{ $t("Cancel") }}</ui-button
                            >
                        </template>
                        <ui-button :class="css_button.append" :disabled="!copy.length" style="margin-left: 8px" @click="methods.copy">{{
                            $t("Copy")
                        }}</ui-button>
                    </div>
                </div>

                <div :class="css.controls">
                    <div :class="css.module">
                        <template v-if="mode != 'codon'">
                            <div :class="[css.legend, css.utr]">UTR</div>
                            <div :class="[css.legend, css.exon]">CDS</div>
                            <div :class="[css.legend, css.intron]" v-if="mode != 'cDNA'">{{ $t("Intron") }}</div>
                        </template>
                    </div>
                    <div :class="css.module">
                        {{ $t("SequenceRetrieval") }}
                        <default-search :class="css.input" v-model="keyword" v-bind="binds.sequence" @search="methods.sequence" />
                        <ui-select
                            v-model="index"
                            v-bind="binds.selector"
                            ref="select3"
                            :class="css.count"
                            :class-extra-name="css.select"
                            style="margin-left: 8px"
                            @change="methods.selector">
                            <template #candidate="{ data }">{{ data.name }}</template>
                        </ui-select>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <!-- * 序列组件 -->
            <module-sequence ref="sequence" @next="methods.prediction" :specie="data.specie" />
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiSelect, UiButton, UiScopeInput, UiModal } from "various-ui";
//* 公共组件
import { DefaultSearch } from "@/components/controls";
//* 私有组件
import ModuleSequence from "@/views/tool/components/sequence/index.vue";
import ModuleNavigations from "@/views/tool/components/navigations/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";
import css_button from "@/assets/style/src/button.module.less";

//* 插件
const route = useRoute();

//* 数据预取
const data = await api.server("GeneMrnas", "/api/gene/mrnas", { data: { id: route.params.id } });

//* 组合函数
const { vars, refs, nodes, binds, methods, computeds } = useComposable(data);
const { exons, file } = computeds;
const { modal, header, select1, select2, select3, sequence } = nodes;
const { modes } = vars;
const { id, copy, mode, exon, index, keyword, inquire, coordinate } = refs;

//* 组件卸载后注销页面滚动事件
onUnmounted(() => window.removeEventListener("scroll", methods.hidden));
//* 组件挂载后获取数据并注册页面滚动事件
onMounted(() => {
    methods.data();
    //* 监听滚动条隐藏下拉框窗口
    window.addEventListener("scroll", methods.hidden);
});
</script>
